// Pace University's undergraduate majors. Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Programs A-Z page
// (catalog.pace.edu/undergraduate/programs-a-z/), which links every program
// under the college or school that offers it, with the degree in the program
// name (BA, BS, BBA, BFA). Kept: every bachelor's major. Left out: minors,
// certificates, associate degrees (AA, AS), combined bachelor's and graduate
// programs (BS/MS, BA/JD and the like), and programs whose catalog page says
// they were discontinued effective Fall 2026 and are no longer open to new
// applicants (every School of Education major, Acting BA, Directing BA,
// General Business BBA, Global Studies BA, Professional Computer Studies BS,
// Professional Technology Studies BS). History BA and Information Systems BS
// are discontinued at Westchester only and stay, marked NYC only. The
// Management and Marketing BBA concentrations are listed once each as the
// major. " Major" is dropped from catalog names ("Accounting Major, BBA" ->
// Accounting, BBA). The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "pace-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major open to new students in Pace's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates, associate degrees, combined bachelor's and graduate programs, and majors the catalog marks as discontinued are left out.",
    "groups": [
        {
            "name": "College of Health Professions",
            "source": {
                "label": "Pace 2026-2027 Undergraduate Catalog, Programs A-Z",
                "url": "https://catalog.pace.edu/undergraduate/programs-a-z/"
            },
            "majors": [
                {
                    "name": "Accelerated Nursing (ABS)",
                    "degree": "BS",
                    "note": "For students who already hold a bachelor's degree in another field."
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Nursing (RN4)",
                    "degree": "BS",
                    "note": "Four-year program, Westchester campus only."
                }
            ]
        },
        {
            "name": "Dyson College of Arts and Sciences",
            "source": {
                "label": "Pace 2026-2027 Undergraduate Catalog, Programs A-Z",
                "url": "https://catalog.pace.edu/undergraduate/programs-a-z/"
            },
            "majors": [
                {
                    "name": "Applied Psychology and Human Relations",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Behavioral-Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business Economics",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communications",
                    "degree": "BA"
                },
                {
                    "name": "Computational Economics",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Digital Cinema and Filmmaking",
                    "degree": "BS"
                },
                {
                    "name": "Digital Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "English, Writing, and Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Screen Studies",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Global Asia Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA",
                    "note": "New York City campus only; closed to new students at Westchester from fall 2026."
                },
                {
                    "name": "International Relations and Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Language, Culture and World Trade",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latina-Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Modern Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Peace and Justice Studies",
                    "degree": "BA"
                },
                {
                    "name": "Personality and Social Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Professional Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Professional Studies",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Writing for Diversity and Equity in Theater and Media",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Lubin School of Business",
            "source": {
                "label": "Pace 2026-2027 Undergraduate Catalog, Programs A-Z",
                "url": "https://catalog.pace.edu/undergraduate/programs-a-z/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Technology",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "International Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Online Business Studies",
                    "degree": "BBA"
                },
                {
                    "name": "Public Accounting",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Sands College of Performing Arts",
            "source": {
                "label": "Pace 2026-2027 Undergraduate Catalog, Programs A-Z",
                "url": "https://catalog.pace.edu/undergraduate/programs-a-z/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Acting for Film and Media",
                    "degree": "BFA"
                },
                {
                    "name": "Commercial Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Musical Theater",
                    "degree": "BFA"
                },
                {
                    "name": "Performance Making",
                    "degree": "BFA"
                },
                {
                    "name": "Production and Design for Stage and Screen",
                    "degree": "BFA"
                },
                {
                    "name": "Stage Management",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Seidenberg School of Computer Science and Information Systems",
            "source": {
                "label": "Pace 2026-2027 Undergraduate Catalog, Programs A-Z",
                "url": "https://catalog.pace.edu/undergraduate/programs-a-z/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Game Development",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS",
                    "note": "New York City campus only; closed to new students at Westchester from fall 2026."
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
